import React, { useMemo } from "react";
import { FaUsers } from "react-icons/fa";
import { KEYS } from "../../Config/Keys";
import { segregateEventAwardsAndReturnQuantity } from "../../utils/utilityFunctions";
import "./SidebarEventCard.css";

function SidebarEventCard({ data }) {
  const awards = useMemo(() => segregateEventAwardsAndReturnQuantity(data?.awards), [data?.awards]);

  return (
    <div className="sidebar-event-card">
      <div className="card-header">
        <img src={KEYS.API + data?.file?.fileUrl} alt="event-logo" className="event-logo" />
        <div className="event-info">
          <h3 className="event-title">{data?.name || "Event Name"}</h3>
          <p className="panel-name">{data?.panelName || "Panel Name"}</p>
          <p className="event-date">
            {new Date(data?.startDate).toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "long"
            })}
          </p>
          <div className="team-count">
            <FaUsers className="icon" /> {data?.registerteams?.length || 0}/{data?.maxTeams || 30}{" "}
            Teams
          </div>
          <div className="sponsor-logos">
            <p>Sponsors:</p>
            <div className="sponsor-placeholder" />
            <div className="sponsor-placeholder" />
          </div>
        </div>
      </div>

      <div className="divider" />

      <div className="awards-section">
        <div className="award-item">
          <img width="31" height="34" src={`/images/icons/cash.svg`} />{" "}
          <span>{awards?.cash || 0}</span>
        </div>
        <div className="award-item">
          <img width="27" height="27" src={`/images/icons/certificate.svg`} />{" "}
          <span>{awards?.certificate || 0}</span>
        </div>
        <div className="award-item">
          <img width="28" height="31" src={`/images/icons/shield.svg`} />{" "}
          <span>{awards?.shield || 0}</span>
        </div>
      </div>
    </div>
  );
}

export default SidebarEventCard;
